<div
  #hostElement
  #languagesDropdown="bs-dropdown"
  dropdown
  [isDisabled]="languages.length === 1"
  [dropup]="isNotMobile"
  [container]="isSystemSelector ? '' : 'body'"
  [ngClass]="isSystemSelector ? 'label-dropdown' : 'form-group'"
  >
  @if (isSystemSelector) {
    <span class="label-dropdown-button" dropdownToggle>
      <i class="globe-icon"></i>
      <span class="label-dropdown-value-wrap text-ellipsis">
        {{ selectedLanguage?.nativeName ?? 'Select language' }}
      </span>
    </span>
  } @else {
    <button dropdownToggle type="button" class="login-dropdown-button text-ellipsis">
      {{ selectedLanguage?.nativeName }}
    </button>
  }


  @if (isSystemSelector) {
    <ul
      *dropdownMenu
      role="menu"
      class="dropdown-menu label-dropdown-menu dropdown-menu-right"
      aria-labelledby="qaDropdown"
      >
      <ng-container
        *ngTemplateOutlet="liTemplate; context: { languages, selectedLanguageId: selectedLanguage.id }"
      ></ng-container>
    </ul>
  } @else {
    <ul
      *dropdownMenu
      role="menu"
      class="login-dropdown-menu with-scroll"
      aria-labelledby="qaDropdown"
      [style.width.px]="hostElement.offsetWidth"
      >
      <ng-container
        *ngTemplateOutlet="liTemplate; context: { languages, selectedLanguageId: selectedLanguage.id }"
      ></ng-container>
    </ul>
  }

</div>

<ng-template #liTemplate let-languages="languages" let-selectedLanguageId="selectedLanguageId">
  @for (language of languages; track language) {
    <li
      role="menuitem"
      class="label-dropdown-menuitem"
      [ngClass]="{ selected: language.id == selectedLanguageId }"
      (click)="changeLanguage(language)"
      >
      {{ language.nativeName }}
    </li>
  }
</ng-template>
